import {Check, Copy} from 'lucide-react'
import { useState } from 'react'
import { copyMarkdown } from '@/lib/calculators'

interface Props {
  markdown: string
  label?: string
  className?: string
}

function CopyButton({ markdown, label = 'Copy Markdown', className = '' }: Props) {
  const [done, setDone] = useState(false)
  const handle = async () => {
    await copyMarkdown(markdown)
    setDone(true)
    setTimeout(() => setDone(false), 1600)
  }
  return (
    <button
      onClick={handle}
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-medium border border-[var(--line-strong)] bg-white/[0.03] text-slate-200 hover:border-emerald-400/50 hover:text-emerald-300 transition ${className}`}
      type="button"
    >
      {done ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5" />}
      {done ? 'Copied' : label}
    </button>
  )
}

export default CopyButton
